import { Box, Tooltip, useTheme } from '@mui/material';
import { EyeIcon, EyeSlashIcon } from '@synergy/theme';
import { FormattedMessage } from 'react-intl';
import { ReactElement, ReactNode } from 'react';

export interface VisibilityIconProps {
    isVisible: boolean;
    isVisibleLabel?: NonNullable<ReactNode>;
    isNotVisibleLabel?: NonNullable<ReactNode>;
}
export const VisibilityIcon = (props: VisibilityIconProps): ReactElement => {
    const {
        isVisible,
        isVisibleLabel = <FormattedMessage id="app.toolTip.hide" />,
        isNotVisibleLabel = <FormattedMessage id="app.toolTip.show" />,
    } = props;
    const theme = useTheme();

    return isVisible ? (
        <Tooltip title={isVisibleLabel} placement="top">
            <Box>
                <EyeIcon sx={{ fontSize: 20 }} />
            </Box>
        </Tooltip>
    ) : (
        <Tooltip title={isNotVisibleLabel} placement="top">
            <Box>
                <EyeSlashIcon sx={{ fontSize: 20 }} htmlColor={theme.palette.grey[400]} />
            </Box>
        </Tooltip>
    );
};
